/**
 * Utilidades para manejar fechas de evento (almacenadas como texto "AAAA-MM-DD").
 *
 * Nunca usar `new Date("AAAA-MM-DD")` para mostrar una fecha: JS la interpreta como
 * medianoche UTC, y al formatear en una zona horaria detrás de UTC (p. ej. Chihuahua)
 * el día se recorre hacia atrás. `parseLocalDate` arma el Date con año/mes/día locales
 * (mediodía implícito), evitando ese corrimiento.
 */
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 12, 0, 0);
};

/** "viernes, 6 de noviembre de 2026" (seguro ante zona horaria). */
export const formatEventDateLong = (dateStr) => {
  const date = parseLocalDate(dateStr);
  if (!date) return dateStr || "";
  return date.toLocaleDateString("es-MX", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
};
